import { useState } from "react";
import axios from "axios";
import { useHistory, useParams } from "react-router-dom";
import translations from "../translations";
import getTranslatedText from "../helpers/getTranslatedText";

function CreateMessageForm() {
  const [name, setName] = useState("");
  const [content, setContent] = useState("");
  const [isSuccessfulReq, setIsSuccessfulReq] = useState(false);

  let history = useHistory();

  function submitMessage(e) {
    e.preventDefault();
    const api = "https://palastine-bk.herokuapp.com/api/v1";
    axios
      .post(`${api}/messages`, {
        name: name,
        content: content,
      })
      .then(() => {
        setIsSuccessfulReq(true);
        reset();
      });
  }

  function reset() {
    setContent("");
    setName("");
  }

  const { lang } = useParams();

  return (
    <>
      <div className="form" id="form">
        <h1>{getTranslatedText(translations, "createMessageTitle", lang)}</h1>

        <form onSubmit={(e) => submitMessage(e)}>
          <label for="fname">
            {getTranslatedText(
              translations,
              "createMessageFormInputName",
              lang
            )}
          </label>
          <br />
          <input
            required
            type="text"
            id="fname"
            value={name}
            onChange={(e) => setName(e.target.value)}
            name="name"
            maxlength="25"
          />
          <br />

          <label for="content">
            {getTranslatedText(
              translations,
              "createMessageFormInputMessage",
              lang
            )}
          </label>
          <br />
          <textarea
            required
            id="content"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            name="content"
            rows="5"
            cols="56"
            maxlength="100"
            style={{ color: "black", height: "100%" }}
          ></textarea>
          <br />

          {isSuccessfulReq && (
            <h2 id="info">
              {" "}
              {getTranslatedText(translations, "createMessageFormFinish", lang)}
            </h2>
          )}
          <h5 id="warning">
            {getTranslatedText(translations, "createMessageFormInfo", lang)}{" "}
          </h5>
          <div>
            <button className="btn-submit" type="submit">
              {getTranslatedText(translations, "createMessageFormSubmit", lang)}
            </button>
          </div>
        </form>

        <button
          class="btn-back"
          type="button"
          onClick={() => history.push(`/${lang}`)}
        >
          {getTranslatedText(translations, "createMessageFormBack", lang)}
        </button>
      </div>
    </>
  );
}

export default CreateMessageForm;
